export enum TrackingSessionKeys {
    DepositSuccess = 'tracking-deposit_success',
    DepositFailure = 'tracking-deposit_failure',
    PurchaseSuccess = 'tracking-purchase_success',
    FTDSuccess = 'tracking-first_time_deposit',
    LoggedIn = 'tracking-logged_in',
    RegistrationSuccess = 'tracking-registration_success',
    CompleteActivation = 'tracking-complete_activation',
    ViewItem = 'tracking-view_item',
    BeginCheckout = 'tracking-begin_checkout',
}

export enum SportRadarEvents {
    Registration = 'track.user.registration',
    Login = 'track.user.login',
    Deposit = 'track.betting.deposit',
}
